// Dropdown: Range Option
// 

JLM.MD.DropdownRangeOption = function( container, value, is_selected ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	let item;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.value = value;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		item = $('<li data-value="' + value + '">' + value + '</li>').appendTo( container );
		if ( is_selected ) item.addClass('selected');
		
		// Events
		item.on('click', select);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Select
	// 
	function select() {
		item.addClass('selected');
		INSTANCE.dispatchEvent('select', [ value ]);
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Deselect
	INSTANCE.select = function() {
		item.addClass('selected');
		is_selected = true;
	};
	INSTANCE.deselect = function() {
		item.removeClass('selected');
		is_selected = false;
	};
	
	// Hide from display
	INSTANCE.hide = function() {
		item.addClass('hidden');
	};
	INSTANCE.show = function() {
		item.removeClass('hidden');
	};
	
	// Measurements
	INSTANCE.getPositionTop = function() {
		return ( container.position().top * -1 ) + item.position().top;
	};
	INSTANCE.height = function() {
		return item.outerHeight();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};